import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { CopyOrder, VendorOrder } from './index';
import { ScopeGuard } from '../../../../../reusable-components/scopes';
import { AwaitButton } from '../../../../../reusable-components/await-button';
import Iconify from '../../../../../reusable-components/iconify';
import { HOST_API_URL } from '../../../../../config-global';

export default function OrderOptions() {
 
  const { facilityId = '' } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const categoryId = urlParams.get('categoryId');

  const handleDownloadOrderSheet = async () => {
    window.open(`${HOST_API_URL}/Api/DownloadOrderSheet?facilityId=${facilityId}&categoryId=${categoryId}`);
  };

  return (
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <CopyOrder />
          <ScopeGuard scopes={['Punchout']} allowAdmin>
            <VendorOrder />
          </ScopeGuard>
          <AwaitButton
            variant="outlined"
            sx={{ ml: 1 }}
            size="small"
            color="secondary"
            onClick={handleDownloadOrderSheet}
            startIcon={<Iconify icon="file-icons:microsoft-excel" />}
          >
            Download
          </AwaitButton>
        </Grid>
  );
}
